import React, { useEffect, useState } from 'react';

import { requestCurrentUserInternal } from 'features/currentUser/api';
import { requestCurrentSubscription } from 'features/subscriptions/api';

type Props = {};

export const Pending: React.FC<Props> = () => {
  const [tries, setTryCount] = useState(0);
  const [success, setSuccess] = useState(false);
  const [failure, setFailure] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      requestCurrentUserInternal().then((user) => {
        if (user.artStreamActive) {
          clearInterval(interval);
          setSuccess(true);
          requestCurrentSubscription()
            .then(({ data }) => {
              const plan = data.interval === 'year' ? 'yearly' : 'monthly';
              fbq('track', 'Purchase', {
                content_category: 'Art Stream',
                // Make sure matches InitiateCheckout
                content_ids: [plan],
                content_name: `Art Stream (${plan})`,
                num_items: 1,
                // 17 is lifetime value of a subscriber
                // Reported by Stripe as of 2020 February
                value: 17,
                currency: 'USD',
              });

              dataLayer.push({
                event: 'artStreamSubscription',
                subscription_id: `SEDSUB${data.id}`,
              });

              setTimeout(() => {
                window.location.href = Routes.welcome_art_stream_path();
              }, 1200);
            })
            .catch(() => {
              bugsnag.notify('Unable to get current subscription');
              setTimeout(() => {
                window.location.href = Routes.welcome_art_stream_path();
              }, 1200);
            });
        }
      });
      setTryCount(tries + 1);
      if (tries === 100) {
        bugsnag.notify('User got stuck on Art Stream pending page');
        clearInterval(interval);
        setFailure(true);
      }
    }, 1000);
  }, []);

  return (
    <div className='page-hero page-hero--viewport text-center'>
      <div className='container'>
        <div className='centered-section-container py-4'>
          <div className='standfirst'>
            {success && <div>Payment successful</div>}
            {!success && !failure && (
              <div>
                <span className='square-spin square-spin--small d-inline-block mr-1' />
                Please wait while we process your payment
              </div>
            )}
            {failure && <div>There was a problem processing your payment</div>}
          </div>
        </div>
      </div>
    </div>
  );
};
